export default "__VITE_ASSET__2rojiJRH__"